import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Permission } from "../../types/permissionType";
import { fetchAllPermissionsThunk, fetchUserPermissionsThunk } from "../thunk/permissionsThunk";

interface PermissionsState {
  allPermissions: Permission[];
  userPermissions: Record<string, Permission[]>;
  currentUserPermissionList: Permission[],
  error?: string;
}

const initialState: PermissionsState = {
  allPermissions: [],
  userPermissions: {},
  currentUserPermissionList: []
};

const permissionsReducer = createSlice({
  name: "permissions",
  initialState,
  reducers: {
    setCurrentUserPermissionList: (state, action: PayloadAction<Permission[]>) => {
      state.currentUserPermissionList = action.payload;
    },
    clearPermissions: (state) => {
      state.userPermissions = {};
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllPermissionsThunk.fulfilled, (state, action) => {
        state.allPermissions = action.payload ? action.payload : [];
        state.error = undefined;
      })
      .addCase(fetchAllPermissionsThunk.rejected, (state, action) => {
        state.error = action.payload as string;
      })
      .addCase(fetchUserPermissionsThunk.fulfilled, (state, action) => {
        const { userId, permissions } = action.payload;
        state.userPermissions[userId] = permissions ? permissions : [];
        state.error = undefined;
      })
      .addCase(fetchUserPermissionsThunk.rejected, (state, action) => {
        state.error = action.payload as string;
      });
  },
});

export const { setCurrentUserPermissionList, clearPermissions } = permissionsReducer.actions;
export default permissionsReducer.reducer;
